// extracted by mini-css-extract-plugin
module.exports = {"button-like":"button-like_button-like__2Wxl1"};